import type { ErrorResponse } from '@apollo/client/link/error';
import type { ServerError } from '@apollo/client/link/utils';
import { SIEBEL_SESSION_EXPIRED_CODE } from '@stratumn/gql-constants';
import type { GraphQLFormattedError } from 'graphql';

const hasSiebelCode = (err: GraphQLFormattedError) =>
  err.extensions?.code === SIEBEL_SESSION_EXPIRED_CODE;

const isServerError = (
  error: ErrorResponse['networkError']
): error is ServerError => !!error && 'result' in error;

const responseHasSiebelCode = (res: Record<string, unknown>) => {
  const { errors } = res;
  if (!Array.isArray(errors)) return false;
  return (errors as GraphQLFormattedError[]).some(hasSiebelCode);
};

export const isSiebelSessionExpired = (
  graphQLErrors?: readonly GraphQLFormattedError[],
  networkError?: ErrorResponse['networkError']
) => {
  if (graphQLErrors?.some(hasSiebelCode)) return true;

  if (isServerError(networkError)) {
    const { result } = networkError;
    const responses = Array.isArray(result) ? result : [result];
    return responses.some(responseHasSiebelCode);
  }

  return false;
};
